let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("961ly")).then(() => parcelRequire('4MtWv'));